<template>
  <div class="left-yellow-container container-fluid">
    <div class="container">
      <div class="left-yellow-container-wrapper">
        <div class="left-yellow-container-body">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$radius: 50px;
.left-yellow-container {
  background-color: #ffbe17;
  padding-left: 0;
  .left-yellow-container-wrapper {
    position: relative;
    margin-right: 0;
    &::before {
      content: "";
      position: absolute;
      top: 0;
      right: -999px;
      left: 0;
      bottom: 0;
      background-color: white;
      border-radius: $radius 0 0 $radius;
    }
    .left-yellow-container-body {
      position: relative;
      min-height: 100px;
    }
  }
}
</style>


<script>
export default {
  name: "YellowBanner",
  props: {
    msg: String
  }
};
</script>